const relationTypes = {
	one: 'One',
	many: 'Many'
}

export default relationTypes
